import React from "react";
import Image from "next/image";

const TeamCard = ({ name, image, role }) => {
  return (
    <>
      <div class="team-card">
        <Image
          src={image}
          alt="Profile Image"
          class="profile-image"
          width={200}
          height={200}
        />
        <div class="person-name">{name}</div>
        <div class="role-title">{role}</div>
      </div>
    </>
  );
};

export default TeamCard;
